export function getVariableValueAsNumber(v: any): number {
    if (isNaN(v)) {
        return 0;
    } else {
        return v;
    }
}
